<template>
    <div class="container-fluid">
       <div class="row">
           <div class="col-12">
               <div class="card">
                   <div class="card-header">
                     <div class="row">
                       <div class="col-lg-3 col-md-4 col-sm-8 col-12 mb-2">
                         <label>Вилоятни танланг</label>
                         <v-select
                             label="label"
                             v-model="populationIncome.data.province"
                             :filterable="false"
                             :options="provinces"
                             @search="onProvinceSearch"
                             @change="onChangeProvince"
                         >
                           <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                         </v-select>
                       </div>
                       <div class="col-lg-3 col-md-4 col-sm-8 col-12 mb-2">
                         <label>Сана</label>
                         <custom-date-picker
                             class="form-control"
                             format="dd/MM/yyyy"
                             v-model="populationIncome.data.date"
                             :date="populationIncome.data.date"
                             :clear-button="true">
                         </custom-date-picker>
                       </div>
                     </div>
                   </div>
                   <div class="card-body">
                     <div class="table-wrapper">
                                  <table class="customers">
                                      <thead>
                                          <tr>
                                              <th rowspan="2">Туман/шахар</th>
                                              <th colspan="2">
                                                  Аҳоли сони
                                                  <span v-if="populationIncome.data.date">{{populationIncome.data.date}}</span>
                                                  холатига
                                              </th>
                                              <th colspan="2">Аҳолининг ўртача даромади</th>
                                              <th colspan="2">Вилоят даромади (Млрд сўм)</th>
                                          </tr>
                                          <tr>
                                              <th>Сони (мингда)</th>
                                              <th>Фоизда(%)</th>
                                              <th width="15%">Аҳоли жон бошига нисбатан (млн сўм)</th>
                                              <th width="15%">Аҳоли жон бошига нисбатан (%)</th>
                                              <th>Сўмда</th>
                                              <th width="5%">Фоизда(%)</th>
                                          </tr>
                                      </thead>
                                      <tbody v-if="regions && regions.length > 0">
                                          <tr v-for="data in populationIncome.data.regionValues" :key="data.region.id">
                                              <td>{{data.region.label}}</td>
                                              <td>
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.populace.value"
                                                                 @input="calculated"
                                                  ></numeric-input>
                                              </td>
                                              <td>
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.populace.percent"
                                                  ></numeric-input>
                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.averageIncome.amount" disabled></numeric-input>
                                              </td>
                                              <td class="text-right">
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.averageIncome.percent" disabled></numeric-input>
                                              </td>
                                              <td>
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.provinceIncome.amount"
                                                                 @input="calculated"
                                                  ></numeric-input>
                                              </td>
                                              <td>
                                                  <numeric-input :precision="2" align="center"
                                                                 v-model="data.provinceIncome.percent" disabled></numeric-input>
                                              </td>
                                          </tr>
                                      </tbody>
                                      <tfoot>
                                          <tr>
                                              <td><b>Жами: </b></td>
                                              <td class="text-right">{{calculatedTotal.totalPopulaceValue | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedTotal.totalPopulacePercent | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedTotal.totalAverageIncomeAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedTotal.totalAverageIncomePercent | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedTotal.totalProvinceIncomeAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-right">{{calculatedTotal.totalProvinceIncomePercent | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                      </tfoot>
                                  </table>
                                </div>
                   </div>
                   <div class="card-footer">
                       <div class="row">
                           <div class="col-12 btns-box">
                               <button class="all-btn delete-btn" @click="cancel">{{$t("action.cancel")}}</button>
                               <button class="all-btn add-btn" @click="save">{{$t("action.save")}}</button>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker'
    import initFilterModel from '@/shared/filter';

    export default {
        components: {
            CustomDatePicker: CustomDatePicker
        },
        data() {
            return {
              processing: false,
              filterProvince: initFilterModel(),
              filterRegion: initFilterModel(),
              provinces: [],
              regions: [],
              populationIncome: {
                  id: null,
                  dictionaryType: 'POPULATION_INCOME',
                  data: {
                      province: null,
                      date: null,
                      regionValues:[
                          {
                              region: null,
                              populace: {
                                  value: 0,
                                  percent: 0
                              },
                              averageIncome: {
                                  amount: 0,
                                  percent: 0
                              },
                              provinceIncome: {
                                  amount: 0,
                                  percent: 0
                              }
                          }
                      ]
                  }
              }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                this.filterProvince.search = '';
                const promises = [
                    this.$http.post('/province/list', this.filterProvince)
                ];
                if (id && id > 0) {
                    promises.push(this.$http.get('dictionary/' + id))
                }
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = vm.getAsMaps(initData)

                    if (values.length >= 2) {
                        const editData = values[1].data;
                        vm.populationIncome = editData;
                    }
                });
                // this.$http.get('/region-borders-setting/init')
                //     .then(res => {
                //         this.provinces = res.data.provinces;
                //     }, err => {
                //         console.log(err)
                //     });
            },
            onChangeProvince() {
                this.regions = [];
                if (this.populationIncome.data.province && this.populationIncome.data.province.id &&
                    this.populationIncome.data.province.id > 0 && this.provinces && this.provinces.length > 0) {
                    this.filterRegion.provinceId = this.populationIncome.data.province.id;
                    this.$http.post('/region/search', this.filterRegion)
                        .then(res => {
                            this.regions = this.getAsMaps(res.data);

                            if (!this.populationIncome.id){
                                this.populationIncome.data.regionValues = this.regions.map(region => ({
                                    region: region,
                                    populace: {
                                        value: 0,
                                        percent: 0
                                    },
                                    averageIncome: {
                                        amount: 0,
                                        percent: 0
                                    },
                                    provinceIncome: {
                                        amount: 0,
                                        percent: 0
                                    }
                                }));
                            }
                        }, err => {
                            console.log(err);
                        });
                }
            },
            save() {
                console.log(this.populationIncome);
                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save',this.populationIncome)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            this.$router.push("/config/population-income");
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            subTotal(data) {
              return data.reduce((prev,item) => prev + item.value,0)
            },
            calculated() {
                this.populationIncome.data.regionValues.forEach(data => {

                    let averageIncomeAmount = 0;
                    let averageIncomePercent = 0;
                    let provinceIncomePercent = 0;

                    if (data.populace.value > 0 && data.provinceIncome.amount > 0) {
                        averageIncomeAmount = data.provinceIncome.amount / data.populace.value;
                    }
                    if (this.calculatedTotal.totalAverageIncomeAmount > 0 && averageIncomeAmount > 0) {
                        averageIncomePercent = (averageIncomeAmount * 100) / this.calculatedTotal.totalAverageIncomeAmount;
                    }
                    if (this.calculatedTotal.totalProvinceIncomeAmount > 0 && data.provinceIncome.amount) {
                        provinceIncomePercent = (data.provinceIncome.amount * 100) / this.calculatedTotal.totalProvinceIncomeAmount;
                    }
                    data.averageIncome.amount = averageIncomeAmount;
                    data.averageIncome.percent = averageIncomePercent;
                    data.provinceIncome.percent = provinceIncomePercent;
                });
            },
            cancel() {
                this.$router.push("/config/population-income");
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = this.getAsMaps(res.data);
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, label: d.name}))
                }
                return [];
            }
        },
        computed: {
            getShortProvinces() {
                return this.provinces.map(province =>({id: province.id, label: province.name}))
            },
            calculatedTotal() {

                let totalPopulaceValue = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.populace.value})));
                let totalPopulacePercent = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.populace.percent})));
                let totalAverageIncomeAmount = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.averageIncome.amount})));
                let totalAverageIncomePercent = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.averageIncome.percent})));
                let totalProvinceIncomeAmount = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.provinceIncome.amount})));
                let totalProvinceIncomePercent = this.subTotal(this.populationIncome.data.regionValues.map(result =>({value:result.provinceIncome.percent})));

                return {
                    totalPopulaceValue: totalPopulaceValue,
                    totalPopulacePercent: totalPopulacePercent,
                    totalAverageIncomeAmount: totalAverageIncomeAmount,
                    totalAverageIncomePercent: totalAverageIncomePercent,
                    totalProvinceIncomeAmount: totalProvinceIncomeAmount,
                    totalProvinceIncomePercent: totalProvinceIncomePercent
                }
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.init();
        }
    }
</script>

<style scoped>

</style>